import { UserGroup, UserGroupUser } from "@/services/users/types";
import Api from "@/services/api";

export async function createUserGroup(group: UserGroup): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/userGroup", group).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAllUserGroups(): Promise<Array<UserGroup>> {
    return new Promise((resolve, reject) => {
        Api.get("/userGroup").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUserGroupById(groupId: string): Promise<UserGroup> {
    return new Promise((resolve, reject) => {
        Api.get(`/userGroup/${groupId}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateUserGroup(group: UserGroup): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/userGroup/", group).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteUserGroup(groupId: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/userGroup/${groupId}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUserGroupsForUser(userId: string): Promise<Array<UserGroup>> {
    return new Promise((resolve, reject) => {
        Api.get(`/userGroup/user/${userId}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getUsersForUserGroup(groupId: string): Promise<Array<UserGroupUser>> {
    return new Promise((resolve, reject) => {
        Api.get(`/userGroup/users/${groupId}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
